import React from 'react'
import { Checkbox, Input, Modal } from 'antd'

const SyncImsatCredentialsModal = ({
  visible,
  username,
  onUsernameChange,
  password,
  onPasswordChange,
  rememberPassword,
  onRememberPasswordChange,
  hasSavedPassword,
  error,
  loading,
  onOk,
  onCancel,
  title,
  okText,
  allowChangeUsername = false,
}) => (
  <Modal
    title={title || 'Cấu hình tài khoản đồng bộ'}
    visible={visible}
    onOk={onOk}
    onCancel={onCancel}
    okText={okText || 'Đồng bộ ngay'}
    cancelText="Hủy"
    confirmLoading={loading}
    className="sync-modal"
    destroyOnClose>
    <style>{`
      .sync-modal .ant-modal-content {
        border-radius: 16px !important;
      }
      .sync-modal .ant-modal-header {
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
      }
      .sync-modal .ant-btn {
        border-radius: 8px !important;
      }
      .sync-modal .ant-input, 
      .sync-modal .ant-input-password,
      .sync-modal .ant-input-affix-wrapper {
        border-radius: 8px !important;
      }
    `}</style>
    <div style={{ marginBottom: 16 }}>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4 }}>Tên đăng nhập</div>
        <Input
          placeholder="Nhập tên đăng nhập"
          readOnly={!allowChangeUsername}
          value={username}
          onChange={e => onUsernameChange(e.target.value)}
          autoComplete="username"
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4 }}>Mật khẩu</div>
        <Input.Password
          placeholder={hasSavedPassword ? 'Đã ghi nhớ mật khẩu (Nhập lại nếu thay đổi)' : 'Nhập mật khẩu'}
          value={password}
          onChange={e => onPasswordChange(e.target.value)}
          autoComplete="current-password"
          onPressEnter={onOk}
        />
      </div>
      <div>
        <Checkbox
          checked={rememberPassword}
          onChange={e => onRememberPasswordChange(e.target.checked)}>
          Ghi nhớ mật khẩu
        </Checkbox>
      </div>
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
    </div>
  </Modal>
)

export default SyncImsatCredentialsModal
